import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Content, Header, Sidebar } from 'Components/Layouts/Organisms'
import { useStore } from 'effector-react'
import { $Account, $AppStore } from 'Models'
import { MainLayoutContext } from 'Components/Layouts/Context'
import { MainLayoutContextProps } from 'Components/Layouts/types'
import { SchoolPath } from 'Constants/Navigation'
import { isSchoolAccount } from 'Utils/AccountRole'

type Props = MainLayoutContextProps

export const MainLayout = (props : Props) => {
  const { isAuthenticated } = useStore($AppStore)
  const account = useStore($Account)
  const { pathname } = useLocation()

  if (!isAuthenticated) {
    return <Navigate to='/sign-in' />
  }

  if (isSchoolAccount(account) && !pathname.startsWith(`/${SchoolPath.main}`)) {
    return <Navigate to={`/${SchoolPath.main}/${SchoolPath.announcements}`} replace />
  }

  return (
    <MainLayoutContext.Provider value={props}>
      <Header />
      <Sidebar />
      <Content>
        <Outlet />
      </Content>
    </MainLayoutContext.Provider>
  )
}
